export default "__VITE_ASSET__b5e28900__"